import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Button from '../Button'
import CodeInputBox from './CodeInputBox'
import { ICSuserTrack, getExactURLValue, getURLValue, getUserGeolocationInfo } from '../Common';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
// import { useNavigate } from 'react-router';
const Wrapper = styled.div`
    display: flex;
    width: 412px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 38px;

    @media screen and (max-width: 767px){
        width: 300px;
    }
`
const Label = styled.div`
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    color: #454545;
    margin-bottom: 12px;

    @media screen and (max-width: 767px){
        font-size: 14px;
    }
`
const CodeWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
`
const InputCode = styled.input`
    width: 43px;
    height: 30px;
    padding: 10px;
    border-radius: 7.494px;
    border: 1px solid #FF7624;
    outline: none;
    background-color: #fff;
    color: #454545;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.989px;
    text-align: center;

    @media screen and (max-width: 767px){
        width: 24px;
        height: 18px;
    }
`

const ErrorWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 414px;

    @media screen and (max-width: 767px){
       width: ${(props) => props.data == 'CESReport' ? '300px' : '414px'};
    }
`

const Error = styled.span`
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #FF4141;
    /* text-align: left; */
    /* margin: 3px 220px 0 0; */
    @media screen and (max-width: 767px) {
        margin-left: ${(props) => (props.data != 'CESReport' ? '14%' : '')};  
        margin: ${(props) => (props.data == 'CESReport' ? '3px 105px 0 0' : '')};  
    }
`

const Error1 = styled.p`
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #FF4141;
    text-align: left;
    margin: 3px 220px 0 0;
    margin: ${(props) => (props.data == 'This code has already been expired' ? '3px 160px 0 0' : '3px 284px 0px 0px')};

    @media screen and (max-width: 767px) {
        margin: ${(props) => (props.data == 'This code has already been expired' ? '3px 55px 0 0' : '3px 170px 0px 0px;')};  
    }
`
const LabelExpire = styled.div`
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    color: #FF4141;
    text-align: center;
    margin-bottom: 12px;

    @media screen and (max-width: 767px){
        font-size: 15px;
    }
`


const LabelVerify = styled.div`
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    color: #23A193;
    text-align: center;
    margin-bottom: 12px;
    width: 530px;
    @media screen and (max-width: 767px){
        font-size: 13px;
    }
`

const ButtonWrap = styled.div`
margin-top: 20px;
`;

const Spinner = styled.span`
&::after {
    content: '';
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    position: absolute;
    border-radius: 50%;
    border-top: 4px solid rgba(255, 255, 255, 1.0);
    border-left: 4px solid rgba(255, 255, 255, 1.0);
    border-right: 4px solid rgba(255, 255, 255, 0.0);
    animation: spinner .6s linear infinite;
  }


  @keyframes spinner {
    to {transform: rotate(360deg);}
  }`

export default function VerifyCode({ directKey, timerValue, setIsLoading, setVerifyError, setVerifySuccess, requestType, reportId, emailId, handleErrorMsgCES, setHandleErrorMsgCES, handleSuccMsgCES, setHandleSuccMsgCES, setVerifiedPayload, handleClose, reportUrl }) {
    const [error, setError] = useState(null);
    const [codes, setCodes] = useState(Array(6).fill(''));
    const [time, setTime] = useState(timerValue);
    const [getTwoButtons, setGetTwoButtons] = useState(false);
    const router = useRouter();
    const currentPath = router.pathname;
    var Url = process.env.NEXT_PUBLIC_SERVER_NAME_URL + currentPath + ".html";
    // var Url = process.env.NEXT_PUBLIC_SERVER_NAME_URL + window.location.pathname;

    // const navigate = useNavigate();

    const getFormattedTime = (time_in_sec) => {
        const min_time = Math.floor(time_in_sec / 60);
        const sec_time = time_in_sec % 60;

        // Add leading zeros if necessary
        const formattedMin = String(min_time).padStart(2, '0');
        const formattedSec = String(sec_time).padStart(2, '0');

        return `${formattedMin}:${formattedSec}`;
    }

    useEffect(() => {
        setInterval(() => {
            setTime((prev) => {
                if (prev != 0)
                    return prev - 1
                else return prev;
            });
        }, 1000)

        return clearInterval();
    }, []);

    useEffect(() => {
        if (requestType == 'GuestLogin') {

            // const encryptedEmail = getExactURLValue('key');
            // const storedTime = localStorage.getItem(encryptedEmail);
            // const storedTime = Cookies.get(encryptedEmail);

            const seconds_since_midnight = getSeconds();

            const storedTime = getURLValue('temp');
            if (storedTime) {
                const timeDiff = seconds_since_midnight - storedTime;
                if (timeDiff < timerValue) {
                    const newTimeValue = timerValue - timeDiff;
                    setTime(newTimeValue);
                } else {
                    setTime(0);
                }
            } else {
                // localStorage.setItem('time', seconds_since_midnight);
                const encrypted_seconds_since_midnight = btoa(getSeconds());
                const newURL = `${window.location.href}&temp=${encrypted_seconds_since_midnight}`;
                window.history.replaceState({}, '', newURL);
            }
        }
    }, []);
    const getSeconds = () => {
        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        const seconds = Math.floor(timestamp / 1000);
        return seconds;
    }

    const callAPIFORFreeReportMailTrigger = (emialId1, reportKey1) => {
        const url = process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL + "/rdt/cesreport/sendfreereportdownloadmail";
        const dataObj = {
            "email": emialId1,
            "reportKey": reportKey1,
            "year": router.asPath.includes("2025") ? "2025" : "2024"
        };
        fetch(url, { method: "POST", headers: { "Content-Type": "Application/json" }, body: JSON.stringify(dataObj) });
    }
    const handleProceed = async () => {

        if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
            ICSuserTrack("", "Clicked on Proceed Button", Url, (requestType == "CESReport" ? "CES 2024 Report" : "Guest Login"), "", Cookies.get("accessid"))
        } else {
            ICSuserTrack(Cookies.get("sesEmail"), "Clicked on Proceed Button", Url, (requestType == "CESReport" ? "CES 2024 Report" : "Guest Login"), Cookies.get("sesUserId"), Cookies.get("accessid"))
        }
        let hasError = false;

        codes.map((digit) => {
            if (digit == '') {
                hasError = true;
            }
        })

        if (hasError) {
            setError('Please enter complete code');
            return;
        } else {
            setError(null);
        }

        setIsLoading(true);
        let passUserfiedcodeFromReportPage = null;
        let userID = getURLValue('key');
        let reportKey = "";
        if (requestType == "CESReport") {
            userID = getExactURLValue('emailid') ? getExactURLValue('emailid') : emailId;
            reportKey = getExactURLValue('reportkey') ? getExactURLValue('reportkey') : reportUrl;
            passUserfiedcodeFromReportPage = (getExactURLValue('emailid') && getExactURLValue('reportkey')) ? "verified" : null;
        }
        const userCode = codes.join('');
        try {
            if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
                ICSuserTrack(userID, `User gives - Email Verification Code ${userCode}`, Url, (requestType == "CESReport" ? "CES 2024 Report" : "Guest Login"), "", Cookies.get("accessid"))
            } else {
                ICSuserTrack(Cookies.get("sesEmail"), `User gives - Email Verification Code ${userCode}`, Url, (requestType == "CESReport" ? "CES 2024 Report" : "Guest Login"), Cookies.get("sesUserId"), Cookies.get("accessid"))
            }
        } catch (error) {
            console.error(error)
        }

        const url = process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL + '/rdt/cesreport/mailcodeverification';
        const inputObj = {
            email: userID,
            code: userCode
        }

        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(inputObj)
        });

        const result = await response.json();

        switch (result.status) {
            case 'Code verified successfully':
                if (requestType == 'GuestLogin') {
                    await callNavigationAPI();
                } else if (requestType == 'CESReport') {
                    // TODO: need to initiate checkout session

                    if (reportId === 1 || reportKey == 'CGYQAYXR' || directKey) { //need to check if the payment is not needed or already is made.
                        callAPIFORFreeReportMailTrigger(userID, (reportKey || directKey));
                        window.location.href = `/viewcesreport.html?emailid=${userID}&reportkey=${reportKey || directKey}`;
                        handleClose();
                        setIsLoading(false);
                    } else {
                        checkUserHavingPermission(userID, reportKey, passUserfiedcodeFromReportPage);
                        // setVerifiedPayload({ email: emailId, reportId: reportId });
                    }
                }
                return;
            case 'Invaild code':
                if (requestType == 'CESReport') {
                    setHandleErrorMsgCES('Enter a valid code');
                    setIsLoading(false);
                    return;
                }
                setError('Enter a valid code');
                setIsLoading(false);
                return;
            case 'Code has been expired':
                if (requestType == 'CESReport') {
                    setHandleErrorMsgCES('This code has already been expired');
                    setIsLoading(false);
                    return;
                }
                setVerifyError('This code has already been expired');
                setIsLoading(false);
                return;
            default:
                setVerifyError('Something went wrong!, Please try again');
                return;
        }

    }

    const initiateCheckoutSession = () => {

    }

    const checkUserHavingPermission = async (emailId, reportUrl, passUserfiedcodeFromReportPage) => {
        let ipAddress = "";
        let userIP = "";
        const userLocationDetails = await getUserGeolocationInfo();
        if (userLocationDetails.usripaddress) {
            ipAddress = userLocationDetails.usripaddress;
        }
        if (userLocationDetails && userLocationDetails.usripaddress) {
            userIP = userLocationDetails.usripaddress;
        }

        const url = process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL + "/rdt/cesreport/reportaccessverfication";
        const dataObj = {
            email: emailId,
            reportKey: directKey || reportUrl,
            ipAddress: ipAddress,
            userAccess: passUserfiedcodeFromReportPage
        }

        const response = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(dataObj) });
        const result = await response.json();
        if (result && result.status == 'user has access') {
            handleClose();
            window.location.href = `/viewcesreport.html?emailid=${emailId}&reportkey=${directKey || reportUrl}&userAccess=verified`;
            setIsLoading(false);
        } else {
            setVerifiedPayload({ email: emailId, reportId: reportId });
            handleClose();
            setIsLoading(false);
        }
    }

    const callNavigationAPI = async () => {

        let geoLocation = "";
        let geoPortal = "";
        const userLocationDetails = await getUserGeolocationInfo();
        if (userLocationDetails) {
            if (userLocationDetails.usrgeolocation) {
                geoLocation = userLocationDetails.usrgeolocation;
            }
            if (userLocationDetails.usergeoportal) {
                geoPortal = userLocationDetails.usergeoportal;
            }
        }

        const emailId = getURLValue('key');

        const url = process.env.NEXT_PUBLIC_SERVER_NAME_URL + '/createsessiontoguest';
        const inputObj = {
            workemaild: emailId,
            geoportal: geoPortal,
            geolocation: geoLocation,
        };

        const designId = getURLValue('designid');
        if (designId) {
            inputObj.designid = designId;
        }


        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(inputObj)
        })

        const result = await response.text();

        const navUrl = process.env.NEXT_PUBLIC_SERVER_NAME_URL + result;

        window.location.href = navUrl;
    }
    const resendCode = async () => {
        setError(null);
        setCodes(Array(6).fill(''));

        if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
            ICSuserTrack("", "Clicked on resend Button", Url, "CES 2024 Report", "", Cookies.get("accessid"))
        } else {
            ICSuserTrack(Cookies.get("sesEmail"), "Clicked on resend Button", Url, "CES 2024 Report", Cookies.get("sesUserId"), Cookies.get("accessid"))
        }
        setIsLoading(true);
        let userID = getURLValue('key');
        if (requestType == "CESReport") {
            userID = getExactURLValue('emailid') ? getExactURLValue('emailid') : emailId;
        }
        let userIP = "";
        const userLocationDetails = await getUserGeolocationInfo();
        if (userLocationDetails && userLocationDetails.usripaddress) {
            userIP = userLocationDetails.usripaddress;
        }
        const url = process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL + '/rdt/cesreport/mailverification';
        const inputObj = {
            type: requestType,
            email: userID,
            ipAddress: userIP,
            reportId: reportId
        }
        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(inputObj)
        })

        const result = await response.json();

        if (result.status == 'verification code has been sent') {
            if (requestType == 'CESReport') {
                setTime(0);
                setHandleSuccMsgCES('A new verification code has been sent to your email address.');
                setGetTwoButtons(true);
                setCodes(Array(6).fill(''));
                setHandleErrorMsgCES('');
                setTimeout(() => {
                    setTime(timerValue - 5);
                    setHandleSuccMsgCES('');
                }, 5000)
            } else {
                setVerifySuccess('A new verification code has been sent to your email address.');
                setTime(timerValue);

                const encrypted_seconds_since_midnight = btoa(getSeconds());
                const currentURL = window.location.href;
                const urlFragment = currentURL.split('&temp')[0];

                const newURL = `${urlFragment}&temp=${encrypted_seconds_since_midnight}`;
                window.history.replaceState({}, '', newURL);
            }

        } else {
            setVerifyError('Unable to send!, Please try again');
        }
        setIsLoading(false);
    }

    useEffect(() => {
        if (time == 0 && requestType == 'CESReport') {
            setHandleErrorMsgCES('');
            setCodes(Array(6).fill(''));
        }
    }, [time])

    return (
        <div>
            <Wrapper>
                {time == 0 ?
                    handleSuccMsgCES ? (handleSuccMsgCES && requestType == "CESReport") && <LabelVerify>{handleSuccMsgCES}</LabelVerify> : <LabelExpire>Your code has expired!</LabelExpire>
                    :
                    <Label>
                        Enter the code sent to your email within
                        <span style={time < 11 ? { fontWeight: "700", color: "red" } : { fontWeight: "700" }}>
                            {" "}{getFormattedTime(time)}
                        </span>
                    </Label>}

                <CodeInputBox
                    codes={codes}
                    setCodes={setCodes}
                    handleProceed={handleProceed}
                />

                {error ?
                    <ErrorWrap data={requestType}>
                        <Error data={requestType}>{error}</Error>
                    </ErrorWrap>
                    : (handleErrorMsgCES && requestType == "CESReport") && <Error1 data={handleErrorMsgCES}>{handleErrorMsgCES}</Error1>
                }

                <ButtonWrap>
                    {getTwoButtons && requestType == "CESReport" && <div style={{ display: 'flex', gap: "12px" }}>
                        <Button variant="outlineOrange" text="Resend Code" width="190px" height="44px" mbwidth="130px" onClick={resendCode}></Button>
                        {(time != 0 || handleSuccMsgCES) && <Button variant="solidOrange" text="Proceed" width="190px" height="44px" mbwidth="130px" onClick={handleProceed}></Button>}
                    </div>}
                    {!getTwoButtons && <Button
                        onClick={time == 0 ? resendCode : handleProceed}
                        text={time == 0 ? "Resend Code" : "Proceed"}
                        variant={time == 0 ? (requestType == "CESReport" ? "solidOrange" : "outlineOrange") : "solidOrange"}
                        width="190px"
                        height="44px"
                        mbwidth="130px"
                    ></Button>}
                </ButtonWrap>

            </Wrapper>

        </div>
    )
}
